"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7265],{

/***/ 7265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ SnipCart; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1720);


function SnipCart() {
    var ref;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), itemsCount = ref1[0], setItemsCount = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref, ref1, ref2, ref3, ref4;
        if (!(window === null || window === void 0 ? void 0 : (ref = window.Snipcart) === null || ref === void 0 ? void 0 : ref.store)) {
            return null;
        }
        var Snip = window === null || window === void 0 ? void 0 : window.Snipcart;
        var initialState = Snip === null || Snip === void 0 ? void 0 : (ref1 = Snip.store) === null || ref1 === void 0 ? void 0 : ref1.getState();
        setItemsCount(initialState === null || initialState === void 0 ? void 0 : (ref2 = initialState.cart) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.items) === null || ref3 === void 0 ? void 0 : ref3.count);
        var unsubscribe = Snip === null || Snip === void 0 ? void 0 : (ref4 = Snip.store) === null || ref4 === void 0 ? void 0 : ref4.subscribe(function() {
            var ref, ref1, ref2;
            var newState = Snip === null || Snip === void 0 ? void 0 : (ref = Snip.store) === null || ref === void 0 ? void 0 : ref.getState();
            setItemsCount(newState === null || newState === void 0 ? void 0 : (ref1 = newState.cart) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.items) === null || ref2 === void 0 ? void 0 : ref2.count);
        });
        return function() {
            return unsubscribe();
        };
    }, [
        setItemsCount
    ]);
    if (false) {}
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("a", {
        href: "#",
        role: "button",
        className: "flex items-center justify-center snipcart-checkout",
        "aria-label": "Shopping Cart",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("span", {
            className: "relative inline-flex pr-2 ",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("svg", {
                    className: "flex-none w-[27px] h-[27px] fill-current",
                    viewBox: "0 0 24 24",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                        d: "M17,18C15.89,18 15,18.89 15,20A2,2 0 0,0 17,22A2,2 0 0,0 19,20C19,18.89 18.1,18 17,18M1,2V4H3L6.6,11.59L5.24,14.04C5.09,14.32 5,14.65 5,15A2,2 0 0,0 7,17H19V15H7.42A0.25,0.25 0 0,1 7.17,14.75C7.17,14.7 7.18,14.66 7.2,14.63L8.1,13H15.55C16.3,13 16.96,12.58 17.3,11.97L20.88,5.5C20.95,5.34 21,5.17 21,5A1,1 0 0,0 20,4H5.21L4.27,2M7,18C5.89,18 5,18.89 5,20A2,2 0 0,0 7,22A2,2 0 0,0 9,20C9,18.89 8.1,18 7,18Z"
                    })
                }),
                itemsCount !== 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                    className: "absolute -top-[7px] right-[4px] flex items-center justify-center w-[18px] h-[18px] p-0 m-0 font-mono text-[10px] text-center text-white bg-red-600 rounded-full top right leading-[normal]",
                    children: itemsCount
                })
            ]
        })
    });
}


/***/ })

}]);